export type Sequence<T> = Exclude<Iterable<T>, string>
